import Vue from 'vue';
import Router from 'vue-router';
import Page from '@/components/Page/';
import About from '@/components/About/';
import Privacy from '@/components/Privacy/';
import Term from '@/components/Term/';
import Eula from '@/components/Eula/';
import Company from '@/components/Hidden/company';
import Investor from '@/components/Hidden/Investor';

import News from '@/components/News/';
import InnerPage from '@/components/News/InnerPage/';
import NewsPage from '@/components/News/NewsPage/';
import EventsPage from '@/components/News/EventsPage/';
import VideosPage from '@/components/VideosPage';

import Sectors from '@/components/Sectors/index';
import SectorsInnerpage from '@/components/Sectors/innerpage';

import Download from '@/components/Download/';

import Career from '@/components/Career/';
import Contact from '@/components/Contact/';
import VueMeta from 'vue-meta';
Vue.use(VueMeta)
// import main from '@/data/main';

Vue.use(Router);



export default new Router({
  mode: 'hash',
  hash: true,
  // base: window.location.pathname,
  routes: [
    {
      name: 'layoutPage',
      component: Page,
      path: '/',
    },
    {
      component: Sectors,
      path: '/sectors',
    },
    {
      component: SectorsInnerpage,
      path: '/sectors/:type',
    },
    {
      component: About,
      path: '/about',
    },
    {
      component: Career,
      path: '/career',
    },
    {
      component: Contact,
      path: '/contact',
    },
    {
      component: Privacy,
      path: '/privacy',
    },
    {
      component: Term,
      path: '/term',
    },
    {
      component: News,
      path: '/news',
    },
    {
      component: NewsPage,
      path: '/news/overview/:id',
    },
    {
      component: InnerPage,
      path: '/news/show/:id/:type',
    },
    {
      component: EventsPage,
      path: '/events',
    },
    {
      component: VideosPage,
      path: '/videos',
    },
    {
      component: Eula,
      path: '/EULA',
    },
    {
      component: Investor,
      path: '/investor',
    },
    {
      component: Company,
      path: '/company',
    },
    {
      component: Download,
      path: '/download/:filename',
    }
   
    
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});
// Add this to remove hash from url.



// WEBPACK FOOTER //
// ./src/router/index.js